var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!!Object.keys(_vm.notificationToDisplay).length)?_c('gc-notification',{attrs:{"is-open":!!Object.keys(_vm.notificationToDisplay).length,"payload":_vm.notificationToDisplay},on:{"close":_vm.dismiss}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }